<script type="text/javascript">
    import EmptyTip from 'views/common/empty'
    import _ from 'underscore'
    import SearchBar from 'components/searchPanel/searchBar'
    import FilterPanel from 'components/filterPanel/filterPanel.vue'
    import FilterPanelItem from 'components/filterPanel/filterPanelItem.vue'

    export default {
        data () {
            return {
                fetchUrl: '/hunter/listHeadCompany.api',
                lists: [],
                timeout: null,
                filterConf: [],
                searchData: {
                    pageIndex: null,
                    pageSize: null
                },
                keyword: this.$route.query.searchWord || '',
                firstRendered: false,     // 第一次loading
                partialLoading: false,    // 局部loading变量
                pagination: {},
                cancels: [],
                httpKey: 0
            }
        },
        watch: {
            '$route': 'fetchData',
            'searchData': {
                handler: function (newVal) {
                    this.$router.push({query: Object.assign({}, newVal)})
                },
                deep: true
            }
        },
        computed: {
            filterKeyArr () {
                return this.filterConf.map(item => item.filter)
            },
            filterNameArr () {
                return this.filterConf.map(item => item.name)
            },
            fetchUrlExtend () {
                return this.filterKeyArr.length ? this.fetchUrl + '?BASE_DATA_KEY=' + this.filterKeyArr.join(',') : this.fetchUrl
            }
        },
        methods: {
            fetchData () {
                let routeQuery = this.$route.query
                let that = this
                // 如果routeQuery为{}时，重置搜索条件(不重置默认值)
                if (!Object.keys(routeQuery).length) {
                    Object.keys(this.searchData).forEach(attr => {
                        this.searchData[attr] = this.searchData[attr] || null
                    })
                }
                Object.assign(this.searchData, routeQuery)

                // 局部loading开启
                this.partialLoading = true

                // 目前这个为了兼容一二三四面
                if (!this.resetSearchDateBeforeFetch()) {
                    return false
                }
                let CancelToken = this.$axios.CancelToken
                that.httpKey++
                let nowHttpKey = that.httpKey
                this.$axios.get(this.fetchUrlExtend, {
                    cancelToken: new CancelToken(function executor(c) {
                        that.cancels.push({cancel: c, httpKey: that.httpKey})
                    }),
                    'X-loadingOff': this.firstRendered,
                    params: Object.assign({}, this.searchData, this.extendParamsBeforeFetch()),
                    timeout: this.timeout || this.$axios.defaults.timeout
                }).then((res) => {
                    that.cancels.map(cv => {
                        if(that.httpKey !== cv.httpKey) {
                            cv.cancel()
                        }
                    })
                    if(nowHttpKey === that.httpKey) {
                        this.lists = res.result.list
                        this.pagination = res.page || this.pagination

                        // 存在是字符串型数字，统一转换成整型
                        Object.keys(this.pagination).forEach(attr => {
                            this.pagination[attr] = parseInt(this.pagination[attr], 10)
                        })

                        // 获取过滤器的基础数据
                        this.filterKeyArr.forEach((key, index) => {
                            // 设置过滤器默认值 - value
                            if (typeof routeQuery[this.filterNameArr[index]] !== 'undefined') {
                                this.filterConf[index].value = routeQuery[this.filterNameArr[index]]
                            }
                            // 设置 data 值
                            if (key && res.result[key]) {
                                this.filterConf[index].data = res.result[key]
                            }
                        })
                        this.firstTimeProcess()
                        this.fetchCallback(res)   
                    }
                }).catch((err) => {
                    if (that.$axios.isCancel(err)) {
                        console.log('Request canceled', err.message)
                    }else{
                        this.lists = []
                        this.firstTimeProcess()
                        console.error(err)
                    }
                })
            },
            resetSearchDateBeforeFetch () {
                return true
            },
            extendParamsBeforeFetch () {
                return {}
            },
            fetchCallback (res) {
            },
            firstTimeProcess () {
                if (!this.firstRendered) {
                    // 第一次渲染要做接下来的逻辑
                    this.firstRendered = true
                }
                // 局部loading关闭
                this.partialLoading = false
            },
            pageSizeChange: function (val) {
                this.searchData.pageSize = val
            },
            pageIndexChange: function (val) {
                this.searchData.pageIndex = val
            },
            searchKeyword (value) {
                this.searchData.searchWord = typeof value === 'string' ? value : this.$refs.searchKeyword.$refs.input.value
                this.searchData.pageSize = null
                this.searchData.pageIndex = null
            },
            checkSearchWord () {
                this.searchInputIcon = (this.$refs.searchKeyword.$refs.input.value.length ? 'circle-close' : '')
            },
            clearSearchWord () {
                this.searchInputIcon = ''
                this.$nextTick(() => {
                    this.$refs.searchKeyword.$refs.input.value = ''
                })
            },
            getParams (middleWare) {
                let params = this.$refs.condition.getParams()
                params = this.dateParamProcess(params)
                if (typeof middleWare === 'function') {
                    middleWare(params)
                }
                this.searchData.pageIndex = 1   // 重置为 1
                this.searchData = Object.assign({}, this.searchData, params)
            },
            dateParamProcess (params) {
                if (_.has(this.searchData, 'startDate') && _.has(params, 'date')) {
                    let dateArr = (params.date && params.date.split(',')) || ['', '']
                    params = Object.assign({}, _.omit(params, 'date'), {startDate: dateArr[0], endDate: dateArr[1]})
                }
                return params
            },
            extendSearchDataFromFilterConf () {
                this.filterNameArr.forEach((key, index) => {
                    this.searchData[key] = this.filterConf[index].value || null
                })
            },
            removeRecordById (id) {
                this.lists = _.reject(this.lists, function (item) {
                    return item.id === id
                })
            }
        },
        created () {
            let self = this
            window.refreshList = function () {
                self.fetchData()
            }
            this.extendSearchDataFromFilterConf()
            this.fetchData()
        },
        components: {
            EmptyTip,
            SearchBar,
            FilterPanel,
            FilterPanelItem
        }
    }
</script>


// WEBPACK FOOTER //
// queryListExtend.vue?94d88342